import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";

export interface EFormForm {
  isProduction: boolean;
  host: string;
  grantType: string;
  integrationVersion: string;
  userName: string;
  password: string;
}

@Component({
  selector: 'ms-form-eform',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './form-eform.component.html',
  styleUrl: './form-eform.component.scss'
})
export class FormEformComponent implements OnInit {

  @Output() formChange = new EventEmitter<EFormForm>();
  @Output() validChange = new EventEmitter<boolean>();

  public form: EFormForm = {
    isProduction: true,
    host: 'https://services.e-forms.be',
    grantType: 'sts_token',
    integrationVersion: '2.3.7',
    userName: 'medispring',
    password: '',
  };

  ngOnInit() {
    this.emitState();
  }

  public onFieldChange() {
    this.emitState();
  }

  private emitState() {
    this.formChange.emit({...this.form});
    this.validChange.emit(this.form.password.trim().length > 0);
  }
}
